import { render, staticRenderFns } from "./elementSnapSlider.vue?vue&type=template&id=19bfdc8c"
import script from "./elementSnapSlider.vue?vue&type=script&lang=ts"
export * from "./elementSnapSlider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconLargeArrowLeft: require('/codebuild/output/src3458403893/src/acredo-website/components/icon/iconLargeArrowLeft.vue').default,IconLargeArrowRight: require('/codebuild/output/src3458403893/src/acredo-website/components/icon/iconLargeArrowRight.vue').default})
